import { read, write } from './_base';
import {
  Billing_Payments_Url,
  Billing_Payment_Url,
  Billing_Payment_Allocate_Url,
  Billing_Payment_Refund_Url,
  Billing_Payments_Withholding_Url,
  Billing_Payments_Links_Url,
} from '../../api/api.endpoints';
import { CreatePaymentPayload, Payment, PaymentAllocation, PaymentListResponse } from '../../schema/billing/payment';

export const listPayments = () =>
  read<PaymentListResponse>(Billing_Payments_Url, 'Failed to load payments').then((r) => r.payments ?? []);

export const getPayment = (id: string) => read<Payment>(Billing_Payment_Url(id), 'Failed to load payment');

export const createPayment = (body: CreatePaymentPayload) =>
  write<Payment>('post', Billing_Payments_Url, { body, errorTitle: 'Payment failed', successTitle: 'Payment recorded' });

export const allocatePayment = (id: string, allocations: PaymentAllocation[]) =>
  write('post', Billing_Payment_Allocate_Url(id), { body: { allocations }, errorTitle: 'Allocation failed', successTitle: 'Allocations posted' });

export const refundPayment = (id: string, amount: string, notes?: string) =>
  write('post', Billing_Payment_Refund_Url(id), { body: { amount, notes }, errorTitle: 'Refund failed', successTitle: 'Refund recorded' });

export const getWithholding = (fiscal_year: string, kind?: string) =>
  read(Billing_Payments_Withholding_Url, 'Failed to load withholding register', { fiscal_year, kind });

export const createRazorpayLink = (document_id: string, description?: string) =>
  write<{ link_id: string; short_url: string; amount: string; currency: string }>('post', Billing_Payments_Links_Url, {
    body: { document_id, description },
    errorTitle: 'Could not create link',
  });
